import { YellowButton, BlueButton, WhiteButton } from "../../Button/button";
import classes from "./popup.module.css";
import Edit from "../../../../assets/images/Onboarding/yellowEdit.svg";
import { useState } from "react";
import { errorHandler, toastSuccess } from "../../../../utils";
import Download from "../../../../assets/images/Onboarding/download.svg";
import Resume from "../../../../assets/images/TalentDashboard/resume.svg";
import { talentResume } from "../../../../services/talentCalls";
import FormData from "form-data";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

const Popup1 = ({ data }) => {
  const [load, setLoad] = useState(false);
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [form, setForm] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result
          .replace("data:", "")
          .replace(/^.+,/, "");

        try {
          setLoad(true);
          const res = await talentResume(
            { talentResume: base64String },
            setProgress
          );

          setLoad(false);
          setForm(false);
        } catch (error) {
          error?.response?.data
            ? errorHandler(error?.response?.data?.errors, "Error")
            : errorHandler(
                "Network error: Something went wrong, Please check your internet connection and try again.",
                "Error"
              );
          setLoad(false);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className={classes.main}>
      <h4>Resume</h4>
      <hr />
      <img src={Resume} alt="resume" className={classes.resume} />
      <hr />
      {load && (
        <div className={classes.progressBar}>
          <div style={{ width: `${progress}%` }}></div>
        </div>
      )}
      {form && (
        <>
          <label className={`flex mt-md mb-md ${classes.upload_resume}`}>
            <input
              type="file"
              accept="application/doc, application/docx, application/pdf"
              onChange={(e) => setFile(e.target.files[0])}
            />{" "}
            <img src={Edit} alt="Edit" />
            Upload new resume
          </label>
          {!!file && <p className="mb-md">{file?.name}</p>}
        </>
      )}
      {!load && (
        <>
          {!form && (
            <div className={`flex ${classes.btn}`}>
              <div className={`flex`}>
                {data?.pdfUrl && (
                  <a
                    className={`flex ${classes.download}`}
                    href={data?.pdfUrl}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={Download} alt="download" />
                    Download Resume
                  </a>
                )}
              </div>
              <YellowButton extra={classes.edit} onClick={() => navigate("/talent-onboarding?stage=1")}>
                <img src={Edit} alt="Edit" /> Edit
              </YellowButton>
            </div>
          )}
          {form && (
            <div className={`flex ${classes.btn}`}>
              <WhiteButton onClick={() => setForm(false)}>Cancel</WhiteButton>
              <BlueButton onClick={handleSubmit}>Save</BlueButton>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Popup1;
